import BannerBg from "../../../assets/images/notAuthBanner.png";
import logo from "../../../assets/images/HeaderLogoDark.svg";
import mobileLogo from "../../../assets/images/HeaderLogoMobile.svg";
import {
  useTheme,
  useMediaQuery,
  Box,
  Typography,
  Button,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import useStyles from "../../Styles/ShowProjectStyles";

type NotAuthBannerProps = {
  redirect?: string;
};

export default function NotAuthBanner({ redirect }: NotAuthBannerProps) {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Box
        className="not-auth-banner"
        style={{ backgroundImage: `url(${BannerBg})` }}
      >
        <Box display={"flex"} alignItems={"center"}>
          <img
            src={isActive ? mobileLogo : logo}
            alt="gains"
            style={{ minWidth: !isActive ? "160px" : "" }}
          />

          {!isActive && (
            <Box
              style={{
                width: "1px",
                height: isActive ? ".8rem" : "1.3rem",
                background: "rgba(0, 0, 0, 0.3",
                margin: isActive ? "0 0.4" : "0 0.8rem",
              }}
            />
          )}
          <Box>
            <Typography
              style={{
                fontSize: isActive ? ".8rem" : "1rem",
                marginLeft: isActive ? ".5rem" : "",
              }}
            >
              Get Access to <span style={{ color: "#3EB8AA" }}>100%</span>{" "}
              refundable deals.
            </Typography>
            {!isActive && (
              <Typography style={{ marginTop: "-5px" }}>
                {" "}
                <span
                  style={{
                    opacity: "0.6",
                    fontSize: isActive ? ".6rem" : ".75rem",
                  }}
                >
                  Log in or Register today.
                </span>
              </Typography>
            )}
          </Box>
        </Box>

        <Box display={"flex"} marginRight={"0rem"} flexDirection={"row"}>
          <Button
            variant="contained"
            color="secondary"
            className={classes.buyGainsButton}
            onClick={() => history.push("/signup")}
            style={{ height: "2.5rem", fontSize: "1rem" }}
          >
            <span style={{ fontSize: isActive ? "0.7rem" : "0.9rem" }}>
              Register
            </span>
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => history.push("/login")}
            className={classes.exploreBtn}
            style={{
              height: "2.5rem",
              fontSize: isActive ? "0.5rem" : "0.8rem",
              marginLeft: ".8rem",
            }}
          >
            <span style={{ fontSize: isActive ? "0.7rem" : "0.9rem" }}>
              Login
            </span>
          </Button>
        </Box>
      </Box>
    </>
  );
}
